import {
  updateAccessibilityRequest
} from "./chunk-2I7HZRP4.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/accessibility/updateRequest.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useUpdateAccessibilityRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateAccessibilityRequest,
    onSuccess: (data) => {
      queryClient.setQueryData(["accessibilityRequests"], (old) => {
        if (old) {
          return __spreadValues(__spreadValues({}, old), data);
        }
        return data;
      });
    }
  });
};

export {
  useUpdateAccessibilityRequest
};
//# sourceMappingURL=chunk-52BCSZMN.mjs.map